import config from "../../Config/config";
import {numberFormat, parseHTML} from "../Core/common";
import {getCartData} from "./get-cart-data";

let cartInfo = {
    count_1: 0,
    count_2: 0,
    total_price: 0,
    not_discount_price: 0,
    count_product: 0,
    total_parts_price: 0,
    discount_total_price: 0,
    count_service: 0,
    price_service: 0,
    discounts: [],
    services: [],
};

const storageName = 'basket_storage';

const printResultQueryForItem = (item, val) => item.innerHTML = numberFormat(val || 0);

const discountTemplate = (discount, title) => {
    return parseHTML(`<div class="characteristic-char-line d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-start position-relative flex-grow-1 ">
                                <span>
                                    <span class="fw-light">${title}</span>
                                </span>
                                <span class="text-sm-end">
                                    <span class="ff-u">
                                        <span class="js_total_price">${discount}</span> руб.
                                    </span>
                                </span>
                            </div>`);
};

function updateCartInfo(data, deliveryPrice = 0, packingPrice = 0) {

    cartInfo = {...cartInfo, ...data};

    localStorage.setItem(storageName, cartInfo.count_1);

    document.querySelectorAll('.js_total_count_cart_full').forEach(item => item.innerHTML = cartInfo.count_2 || 0);
    document.querySelectorAll('.js_total_count_cart').forEach(item => item.innerHTML = cartInfo.count_1 || 0);

    const basketLink = document.querySelector('.js_basket_link');

    if(basketLink && cartInfo.count_1 || 0){
        basketLink.classList.add('active');
    }else if(basketLink){
        basketLink.classList.remove('active');
    }

    let d_price = parseInt(cartInfo.total_price);
    let n_price = parseInt(cartInfo.not_discount_price);
    deliveryPrice = parseInt(deliveryPrice);
    packingPrice = parseInt(packingPrice);

    let TotalPrice = numberFormat((d_price + deliveryPrice + packingPrice));
    let OTotalPrice = numberFormat((n_price + deliveryPrice + packingPrice));

    const mobileTotalPrice = document.querySelector('.js_mobile_total_price');
    if(mobileTotalPrice && cartInfo.count_1 || 0){
        mobileTotalPrice.innerHTML = `${numberFormat(TotalPrice || 0)} ₽`;
    }else if(mobileTotalPrice){
        mobileTotalPrice.innerHTML = "Корзина";
    }
    document.querySelectorAll('.js_total_price').forEach(item => printResultQueryForItem(item, TotalPrice));


    document.querySelectorAll('.js_old_total_price').forEach(item => {
            item.innerHTML = '';
            if (TotalPrice !== OTotalPrice) {
                item.append(discountTemplate(OTotalPrice, 'Итоговая стоимость'));
            }
        }
    );

    document.querySelectorAll('.js_total_product_count').forEach(item => printResultQueryForItem(item, cartInfo.count_product));

    document.querySelectorAll('.js_total_product_price').forEach(item => printResultQueryForItem(item, cartInfo.total_parts_price));

    document.querySelectorAll('.js_total_service_count').forEach(item => printResultQueryForItem(item, cartInfo.count_service));

    document.querySelectorAll('.js_total_service_price').forEach(item => printResultQueryForItem(item, cartInfo.price_service));

    document.querySelectorAll('.js_total_discount_price').forEach(item => printResultQueryForItem(item, cartInfo.discount_total_price));

    document.querySelectorAll('.js_packing_price').forEach(item => printResultQueryForItem(item, packingPrice));

    document.querySelectorAll('.js_delivery_price').forEach(item => printResultQueryForItem(item, deliveryPrice));

    document.querySelectorAll('.js_discount_block').forEach(item => item.parentNode.removeChild(item));

    const beforeDiscount = document.querySelector('.js_before_discount');
    if (beforeDiscount) {
        beforeDiscount.innerHTML = '';
        if (Array.isArray(cartInfo.discounts)) {
            cartInfo.discounts.forEach(item => {
                beforeDiscount.append(discountTemplate(...item));
            });
        }
    }
    document.querySelectorAll(`.js_service_title`).forEach(item => item.innerHTML = '');
    cartInfo.services.forEach(item => {
        let js_service_title = document.querySelector(`.js_service_title[data-id="${item.product_id}"]`);
        if(js_service_title){
            js_service_title.innerHTML = item.title;
        }
    });
}

export const cartInfoInit = events => {
    cartInfo.count_1 = localStorage.getItem(storageName) || 0;

    document.querySelectorAll('.js_total_count_cart').forEach(item => {
        item.classList.remove('preloader');
        item.innerHTML = cartInfo.count_1;
    });

    let js_total_price = document.querySelector('.js_total_price.preloader');
    if (js_total_price) {
        if (parseInt(cartInfo.count_1)) {
            getCartData('', '').then(e => {
                if (e) {
                    updateCartInfo(e);
                }
                js_total_price.classList.remove('preloader');
            });
        } else {
            js_total_price.classList.remove('preloader');
        }
    }


    events.addListener(config.listeners.basket.added, null, updateCartInfo);
    events.addListener(config.listeners.basket.deleted, null, updateCartInfo);
    events.addListener(config.listeners.basket.update, null, updateCartInfo);
};


